import React, { useEffect, useRef, useState, } from 'react';

interface DynamicTextAreaProps{
    areaText: string,
    updateText: (text:string)=>void ,
    placeholder: string
}



const DynamicTextArea = (props: DynamicTextAreaProps)=>{

    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [areaText, setAreaText] = useState(props.areaText);
    useEffect(() => {
        if (areaText !== props.areaText){
            // console.log("useeffect dynamictextarea "+props.areaText+" !== "+areaText);
            updateSize();
        }
    }, [areaText, props.areaText]);

    function updateSize(){
        if (textareaRef.current != null){
            textareaRef.current.style.height = textareaRef.current.scrollHeight + "px"
        }
    }

    return(  
        <textarea onInput={(e)=>updateSize()}
            value={areaText}
            placeholder={props.placeholder}
            className={"col-12 form-control mb-2"}
            ref={textareaRef}
            style={{}}
            onChange={e => {
                setAreaText(e.target.value)
                props.updateText(e.target.value)
                if (textareaRef.current != null){
                    textareaRef.current.style.height = textareaRef.current.scrollHeight + "px"
                }
            }}
        ></textarea>
    );
}

export default DynamicTextArea;